export const NAME = 'app';
export const NAMESPACE = NAME;
